import styled, { css } from "styled-components";

export const ModalOverlay = styled.div`
  inset: 0;
  width: 100%;
  background-color: rgba(25, 25, 25, 0.75) !important;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  margin: auto;
  margin-top: 2rem;
  width: 62.4375rem;
  max-height: 90vh;
  background: var(--black-200) !important;
  border-radius: 4px;
  border: none !important;
  padding: 1.25rem 0rem;

  .close-pictures-report-modal {
    cursor: pointer;
    position: absolute;
    top: 1rem;
    right: 1rem;
  }

  @media (min-width: 1440px) {
    height: auto;
    max-height: 85vh;
  }
`;

export const Distance = styled.span`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  color: var(--white);
  text-decoration: underline;
  text-decoration: none;
`;

export const MoreDetailsContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;

  header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.625rem 2rem;
    width: 100%;
    border-bottom: 1px solid rgba(82, 82, 82, 0.64);
  }
`;

export const ReportContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28.75rem;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const VehicleInformation = styled.div`
  display: grid;
  grid-template-rows: 3fr 2fr;
  width: 100%;
`;

export const VehicleKm = styled.div`
  padding: 1.5rem 2rem;
  width: 100%;
  border-bottom: 1px solid rgba(82, 82, 82, 0.64);

  h4 {
    font-family: "DM Sans";
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.5rem;
    color: var(--white);
    margin-bottom: 1rem;
  }
`;

export const VehicleKmContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  span {
    margin-right: 5.125rem;
    margin-bottom: 1rem;

    &:last-of-type {
      margin-bottom: 0;
    }

    h4 {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 0.875rem;
      line-height: 1.375rem;
      color: var(--grey-100);
      margin-bottom: 0.25rem;
    }

    p {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.5rem;
      color: var(--grey-200);
    }

    a {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.5rem;
      color: var(--white);
      text-decoration: underline;

      &:hover {
        cursor: pointer;
      }
    }
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 2rem;
  margin: auto;
  gap: 1.2rem;

  * {
    flex-grow: 1;
  }

  button {
    width: 108px;
    transition: background 0.3s;

    &:disabled {
      background: var(--white) !important;
      cursor: default;
    }
  }

  button:first-of-type {
    background-color: var(--white);
  }

  input {
    margin-top: 0;
    transition: background 0.3s;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`;

export const AttachmentGalleryContainer = styled.div`
  width: 100%;
  height: 100%;
  border: 1px solid #3d3d3d;
`;

export const IntrusionContainer = styled.div`
  display: grid;
  grid-template-columns: 0.2fr 1fr;
  width: 100%;
  padding: 2rem;
  height: 10.25rem;
  overflow-x: scroll;
  overflow-y: hidden;

  span {
    h4 {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 0.875rem;
      line-height: 1.375rem;
      color: var(--grey-100);
    }

    p {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.5rem;
      color: var(--white);
      margin-top: 0.25rem;
    }
  }

  div {
    display: flex;
    flex-direction: column;
    width: 100%;

    h4 {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.5rem;
      color: var(--white);
      margin-bottom: 0.75rem;
    }

    div {
      display: flex;
      flex-direction: row;
      align-items: center;

      div {
        border: 1px dashed #525252;
        width: 4.5rem;
        height: 4rem;
        background-color: transparent;
        border-radius: 0.25rem;
        margin-right: 1rem;
      }

      div:last-of-type {
        margin-right: 0;
        justify-content: center;
        align-items: center;

        p {
          font-family: "Inter";
          font-style: normal;
          font-weight: 400;
          font-size: 0.875rem;
          line-height: 1.375rem;
          color: var(--grey-100);
        }
      }

      img {
        border: 1px dashed #525252;
        width: 100%;
        height: 100%;
        background-color: transparent;
        border-radius: 0.25rem;
        margin-right: 1rem;
        object-fit: cover;
      }

      img:last-of-type {
        margin-right: 0;
        object-fit: cover;
      }

      img:hover {
        cursor: pointer;
      }
    }
  }
`;

type OccurrenceStatusVariants = "aguardando" | "andamento" | "finalizado";

type OccurrenceStatusProps = {
  variant: OccurrenceStatusVariants;
};

const occurrenceStatusVariants = {
  aguardando: css`
    background: var(--darker-primary);
    justify-content: center;
    align-items: center;
    height: 2rem;
    padding: 0.5625rem 0.75rem;
    border-radius: 6.25rem;
    font-size: 0.75rem;
    color: var(--primary);
    margin-left: 2rem;
    text-align: center;
    font-family: "Inter";
    font-weight: 400;
    line-height: 0.875rem;
  `,
  finalizado: css`
    justify-content: center;
    align-items: center;
    height: 2rem;
    padding: 0.5625rem 0.75rem;
    border-radius: 6.25rem;
    font-size: 0.75rem;
    color: var(--green);
    margin-left: 2rem;
    text-align: center;
    font-family: "Inter";
    font-weight: 400;
    line-height: 0.875rem;
    background: rgba(71, 212, 68, 0.1);
  `,
  andamento: css`
    justify-content: center;
    align-items: center;
    height: 2rem;
    padding: 0.5625rem 0.75rem;
    background: rgba(235, 235, 235, 0.1);
    border-radius: 6.25rem;
    font-size: 0.75rem;
    color: var(--white);
    margin-left: 2rem;
    text-align: center;
    font-family: "Inter";
    font-weight: 400;
    line-height: 0.875rem;
  `,
};

export const OccurrenceStatus = styled.div<OccurrenceStatusProps>`
  width: 7rem;
  ${({ variant }) => occurrenceStatusVariants[variant]};
`;

export const Footer = styled.footer`
  width: 100%;
  border-top: 1px solid rgba(235, 235, 235, 0.1);
`

export const NoSelectedReportContainer = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;

  h2 {
    text-align: center;
    width: 100%;
  }
`

export const AutoCompleteContainer = styled.div`
  width: 100%;
  height: fit-content;
  padding: 1rem;
`